(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources",
                {
                    url: "/Resources",
                    component: "resources"
                });
        }
    ]);

    app.component("resources",
        {
            templateUrl: "App/Resources/Resources.html",
            controller: resourcesController
        });


    resourcesController.$inject = ["$mdToast", "$mdDialog", "$state", "$timeout"];


    function resourcesController($mdToast, $mdDialog, $state, $timeout) {
        var $ctrl = this;

        $ctrl.goBack = function () {

            //if ($state.$current.parent.self.name !== "Home.Resources")
            //$state.go($state.$current.parent.self.name, $state.params);
            $timeout(function () { history.go(-1); }, 400);

        };
    }

    app.config(["$urlRouterProvider", function ($urlRouterProvider) {
        $urlRouterProvider.when("/Resources", "/Home");
    }]);

})(window.app); // jshint ignore:line